import Enum from '/@/modules/core/app/helpers/Enum';

export class PredefinedCurrency extends Enum {
  static USD = {
    id: 1,
    symbol: '$',
    name: 'US Dollar',
    code: 'USD',
    active: true
  };

  static CAD = {
    id: 2,
    symbol: '$',
    name: 'Canadian Dollar',
    code: 'CAD',
    active: true
  };
}
